export default __webpack_public_path__ + "static/media/virtual-bg3.010d5f09.png";